import React, { Component } from 'react';
import axios from 'axios';
import PropTypes from 'prop-types';
import { withRouter } from '../helpers/withRouter';
import { NavLink } from "react-router-dom";
import { BlogBBPLink } from '../helpers/Common';
import Teaser from '../blocks/Teaser';

export class BlogBBPLasts extends Component {

    static propTypes = {
        match: PropTypes.object.isRequired,
        location: PropTypes.object.isRequired,
        history: PropTypes.object.isRequired
    };

    constructor( props ){

        super( props )

        this.state = {
            isLoaded: false,
            isMobile: false,
            items: []
        }
    
    }

    componentDidMount () {

        const SERVER_URL = process.env.REACT_APP_SERVER_URL;

        axios.get( SERVER_URL + 'wp-json/wp/v2/blogbbp?per_page=8&siteID=' + window.siteID )
            .then(res => this.setState({
                isLoaded: true,
                items: res.data
            }))
            .catch(err => console.log(err))
        ;
        
    }

    render() {

        const { items, isLoaded } = this.state;
        if( !isLoaded || !items.length ) return null;

        return (
            <section id="blogbbp-lasts" className="teasers-list blogbbp-lasts">
                <div>
                    <header>
                        <h3>Últimos Conteúdos</h3>
                        <em>Conteúdos exclusivos desenvolvidos especialmente para você.</em>
                    </header>
                    <ul>
                        {items.map( ( item ) => {
                            const url = BlogBBPLink( item );
                            return (
                                <Teaser key={item.custom.slug} data={item} url={url} type="2"></Teaser>
                            );
                        })}
                    </ul>
                    <NavLink to="/blogbbp/listar" className="button default" title="Ver todos os conteúdos">
                        Ver todos os Conteúdos
                    </NavLink>
                </div>
            </section>
        )
   
    }

}

export default withRouter( BlogBBPLasts );